<template>
  <div>
    <el-card>
      <edit-form
        :disabled="isDisableEditForm"
        ref="editForm"
        :data="formData"
        @changeTaskRangeFlag="changeTaskRangeFlag"
      />
      <range-list
        class="mt-2"
        ref="rangeList"
        :disabled="isDisableEditForm"
        :data="formData"
        :taskRangeFlag="taskRangeFlag"
      />
      <div
        class="d-flex justify-content-end mt-2 mb-2"
        v-if="!isDisableEditForm"
      >
        <el-button type="primary" size="small" @click="save()">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </div>
    </el-card>
    <el-card class="mt-2" v-if="rangeDetailListShow">
      <range-detail-list
        ref="rangeDetailList"
        :disabled="isDisableEditForm"
        :code="code"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import RangeList from '../components/edit-form/range.vue'
import RangeDetailList from '../components/edit-form/range-detail'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  name: 'samplemanage-sampleStockCheck-detail',
  components: {
    EditForm,
    RangeList,
    RangeDetailList
  },
  mixins: [EditLoading],
  data() {
    return {
      code: '',
      formData: {
        taskStatus: 'N'
      },
      taskRangeFlag: ''
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
    rangeDetailListShow() {
      return (
        this.formData.taskStatus !== 'N' && this.formData.taskStatus !== 'D'
      )
    }
  },
  mounted() {
    this.code = this.params.code
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      this.formData = { taskStatus: 'N', rangeList: [] }
      if (!this.code) {
        return
      }
      this.$api
        .stockCheckTaskDetailApi({
          taskCode: this.code
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    changeTaskRangeFlag(val) {
      this.taskRangeFlag = val
    },
    async save() {
      // 获取主信息
      const getFormData = await this.$refs.editForm.getFormData()
      if (!getFormData) {
        return
      }
      // 获取盘点范围信息
      const dataList = await this.$refs.rangeList.getListData()
      if (dataList.length == 0) {
        this.$message({
          showClose: true,
          message:
            this.$l('tips_choose_select_range_detail') || '选择盘点范围明细',
          type: 'warning'
        })
        return
      }
      let params = {
        ...getFormData,
        dataList
      }
      this.loadingOpen()
      this.$api
        .stockCheckTaskSaveApi(params)
        .then(() => {
          this.loadingClose()
          this.saveOkQuestion()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          }
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false
      })
    }
  }
}
</script>

